// src/v3/TypographyRhythm/index.tsx
import { cx } from "class-variance-authority";
import { jsx } from "react/jsx-runtime";
function TypographyRhythm({
  children,
  className,
  hideOverflow = false,
  ...props
}) {
  return /* @__PURE__ */ jsx("div", {
    className: cx("TypographyRhythm", className, {
      hideOverflow
    }),
    "data-cy": "TypographyRhythm",
    ...props,
    children
  });
}
export {
  TypographyRhythm
};
//# sourceMappingURL=index.mjs.map